import Vue from 'vue'

Vue.filter('getSatisfactionColorByValue', val => {
  if (val >= 1 && val <= 2.5) {
    return 'bg-danger';
  } else if (val > 2.5 && val <= 3.8) {
    return 'bg-warning';
  } else if (val > 3.8) {
    return 'bg-success';
  }
});

